export enum DnsRecordType {
  Txt = "TXT",
  Cname = "CNAME",
  Mx = "MX",
  Ns = "NS",
  A = "A",
}
